import React from 'react'
import { Grid, Typography } from '@mui/material'
import { InputText, ButtonLoading, Loading, Alerts } from '../../../Simple'
import SettingsHook from '../SettingsHook'

import { stMob } from './styles'
import { UsuarioContext } from '../../../../contexts/UsuarioContext'
import md5 from 'md5'

export default function AlterPassword() {
  const { actionsUCtx, loadsUCtx } = React.useContext(UsuarioContext)
  const { sttPgStt, inpsStt, loadStt, actionsSettings } = SettingsHook()

  async function SalvarNewDados() {
    if (inpsStt.senha === '' || inpsStt.newSenha === '' || inpsStt.confirmSenha === '')
      Alerts.swal('warning', 'Aviso', 'Para realizar a troca da senha, é necessário preencher todos os campos')
    else {
      if (inpsStt.newSenha === inpsStt.confirmSenha) {
        await actionsUCtx.ChangePassUser(md5(inpsStt.senha), md5(inpsStt.newSenha))
        actionsSettings.clearPassInps()
      } else return Alerts.swal('warning', 'Senhas não iguais', 'As senhas não iguais, por favor verifique-as e insira novamente')
    }
  }

  return (
    <>
      {loadsUCtx.updateUserPass ? (
        <div className='contain-loading'>
          <Loading text={'Atualizando suas credenciais'} />
        </div>
      ) : (
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Typography sx={stMob.labelPage} variant='body1'>
              Para fazer a alteração, será necessário informar tanto sua senha atual como uma nova com no mínimo 5 caracteres. Caso você não lembre de
              sua senha, você pode desconectar-se da conta e solicitar uma redefinição.
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <InputText
              type='password'
              label='Senha Atual'
              value={inpsStt.senha}
              onChange={e => {
                actionsSettings.handleInpsStt('senha', e.target.value)
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <InputText
              type='password'
              label='Nova Senha'
              value={inpsStt.newSenha}
              onChange={e => {
                actionsSettings.handleInpsStt('newSenha', e.target.value)
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <InputText
              type='password'
              label='Confirme a Nova Senha'
              value={inpsStt.confirmSenha}
              onChange={e => {
                actionsSettings.handleInpsStt('confirmSenha', e.target.value)
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <ButtonLoading
              loading={loadStt.newPass}
              disabled={sttPgStt.newPassOk}
              label='Alterar Senha'
              onClick={() => {
                SalvarNewDados()
              }}
            >
              Alterar Senha
            </ButtonLoading>
          </Grid>
        </Grid>
      )}
    </>
  )
}
